import { useAppState } from "../containers";
import { useEffect, useState } from "react";

export const useThemedAsset = (assetPattern: string) => {
  const { copy } = useAppState();
  const [assetUrl, setAssetUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (copy) {
      setAssetUrl(
        process.env.PUBLIC_URL + assetPattern.replace("{theme}", copy)
      );
    }
  }, [copy, assetPattern]);

  return assetUrl;
};
